import router from 'next/router';
import {t, tt} from '../common/getTranslations';
import {requestContext} from '../common/requestContext';
import {API_STATUS_MESSAGE_MAP} from '../common/shared/api/nicolas/ApiStatusMessageMap';
import {
  removeSimpleDialog,
  showSimpleDialog,
} from '../dialog/simpleDialogHandler';
import {LOG_CLICK_EVENT} from '../logging/logEvent';
import {SerializedPagewebError} from './SerializedPagewebError.interface';

const routeBackRegexArr = [/\/content\/\d+\/viewer\/\d+/, /\/buy\/ticket/];

export function handleRestrictedCountryDeniedError(
  error: SerializedPagewebError
) {
  const errorMsg = API_STATUS_MESSAGE_MAP[error.resultCode as number]
    ? tt(API_STATUS_MESSAGE_MAP[error.resultCode as number])
    : t('error_api_toast');

  function handler() {
    for (const regex of routeBackRegexArr) {
      if (regex.test(router.asPath)) {
        router.back();
        break;
      }
    }
    removeSimpleDialog();
  }

  showSimpleDialog({
    title: '',
    description: errorMsg,
    isMobile: requestContext.requestInfo.display.isMobile,
    okButton: {
      type: 'label',
      text: t('common_confirm_button'),
      onClick: e => LOG_CLICK_EVENT('국외제한팝업_확인_클릭', e, handler),
      closeAfterClick: true,
    },
    onClose: handler,
    eventLog: {
      click: {
        layer1: '국외제한팝업',
        imp_id: 'popup',
        imp_provider: 'service',
      },
      viewimp_contents: {
        imp_id: 'popup',
        imp_provider: 'service',
        imp_type: 'vimp',
        layer1: '국외제한팝업',
      },
      customProps: {popup_type: '국외제한팝업'},
    },
  });
}
